export type SeasonKey = 'SUGARCANE_2024';

export const polygonFilterSugarcane2024 = {
	combiningOperator: 'AND',
	baseConditions: [
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'SUGARCANE_2024_STATUS',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['GEOFENCING_SAVED'],
				},
			},
		},
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'GEOFENCE_SOURCE',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['MAPS PORTAL'],
				},
			},
		},
	],
};

export const SUGARCANE_SEASON_CONFIG: Record<
	SeasonKey,
	{
		dataLayers: string[];
		label: string;
		suggestionLayers?: string[];
		filters: Record<string, any>;
		portalLockPropertyKey?: string;
		parentPointPropertyKey?: string;
		parentRefAttributeKey?: string;
		programNames: string[];
		geofenceFlowVersion: number;
		geofenceStatusPropertyKey: 'SUGARCANE_2024_STATUS';
		geofenceRejectionReasonsPropertyKey: 'SUGARCANE_24_REJ_REASONS';
	}
> = {
	SUGARCANE_2024: {
		dataLayers: ['FARMS-USER_FARM-SUGARCANE_24_PROGRAM_TYPE'],
		label: 'Sugarcane 2024',
		suggestionLayers: ['FARMS-SATELLITE_FARM-VILLAGE_FARM'],
		filters: {
			'FARMS-USER_FARM-SUGARCANE_24_PROGRAM_TYPE':
				polygonFilterSugarcane2024,
		},
		geofenceFlowVersion: 2,
		geofenceStatusPropertyKey: 'SUGARCANE_2024_STATUS',
		geofenceRejectionReasonsPropertyKey: 'SUGARCANE_24_REJ_REASONS',
		programNames: ['SUGARCANE_PROGRAM_24'],
	},
};
